import { useRef, useEffect } from 'react'

const utils = {
  overlayJoinPages: {
    JOIN_GROUP: 'JOIN_GROUP',
    MAX_GROUPS: 'MAX_GROUPS',
  },
}

export default utils

// https://stackoverflow.com/a/60498111/1183452
export const useInterval = (callback, delay) => {
  const savedCallback = useRef()

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    function tick() {
      savedCallback.current()
    }
    if (delay !== null) {
      const id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
    return () => {}
  }, [delay])
}
